var React = require('react');

function Billing (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5B00DB","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M20.481 5H3.518C2.68 5 2 5.68 2 6.518v11.08c0 .84.68 1.52 1.518 1.52h16.963c.839 0 1.519-.68 1.519-1.52V6.519C22 5.68 21.32 5 20.481 5zM5.5 15.5h4M12.5 15.5h1M2.5 9.5h19"})));
}

Billing.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Billing;

Billing.default = Billing;
